import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import FounderDesk from "@/components/FounderDesk";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { Toaster } from "sonner";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#0A0D14]">
      <Header />
      <Hero />
      <Services />
      <FounderDesk />
      <Testimonials />
      <Contact />
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-right" theme="dark" />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
